import { VideoCameraSlashIcon as PhosphorVideoCameraSlashIcon } from "@phosphor-icons/react/dist/ssr/VideoCameraSlash";

import { createAppIcon } from "@/components/createAppIcon";

export const VideoDisabledIcon = /* @__PURE__ */ createAppIcon(PhosphorVideoCameraSlashIcon);
